import { LoginForm } from "../components/login-form";

export const LoginPage: React.FC = () => {
  return <LoginForm />;
};
